import React from 'react';
import { Link } from 'react-router-dom';
import { FiPackage, FiTruck, FiShield, FiAward, FiUsers, FiClock, FiThumbsUp, FiHeadphones, FiHeart } from 'react-icons/fi';

const About = () => {
  const features = [
    {
      icon: FiPackage,
      title: 'ផលិតផលថ្មី',
      description: 'ផលិតផលស្រស់ៗ ១០០% ពីកសិករក្នុងស្រុក មានគុណភាពខ្ពស់ ធានាដើម',
      color: 'red'
    },
    {
      icon: FiShield,
      title: 'ធានាគុណភាព',
      description: 'ធានាផលិតផលស្រស់ និងសុវត្ថិភាព ១០០% ពីញ៉ាំក្នុងស្រុក',
      color: 'red'
    },
    {
      icon: FiTruck,
      title: 'ដឹកជញ្ជូនលឿន',
      description: 'ដឹកជញ្ជូនទូទាំងប្រទេស ទទួលបានក្នុងរយៈពេល ២៤-៤៨ម៉ោង',
      color: 'red'
    },
    {
      icon: FiHeadphones,
      title: 'សេវាអតិថិជន',
      description: 'ក្រុមការងារជំនាញ ផ្តល់សេវាកម្មរហ័ស និងរួសរាយរាក់ទាក់',
      color: 'red'
    }
  ];

  const stats = [
    { number: '3+', label: 'ឆ្នាំបទពិសោធន៍', icon: FiAward },
    { number: '5,000+', label: 'អតិថិជនពេញចិត្ត', icon: FiUsers },
    { number: '24/7', label: 'សេវាកម្ម', icon: FiClock },
    { number: '100%', label: 'គុណភាព', icon: FiThumbsUp }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Hero Section */}
      <div className="mb-12 text-center">
        <h1 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">
          អំពី<span className="text-red-600">GrandFatherSmile</span>
        </h1>
        <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
          GrandFatherSmile គឺជាវេបសាយសម្រាប់លក់ផលិតផលរបស់ញ៉ាំក្នុងស្រុក 
          បង្កើតឡើងដោយកូនខ្មែរ ផ្តល់ជូននូវផលិតផលស្រស់ មានគុណភាព 
          ជាមួយនឹងការធានាផលិតផល និងសេវាកម្មក្រោយពេលលក់ដ៏ល្អប្រសើរ
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div key={index} className="bg-white border border-gray-200 p-6 hover:border-red-200 transition-all">
              <div className="mb-4">
                <Icon size={32} className="text-red-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          );
        })}
      </div>

      {/* Stats Section */}
      <div className="bg-red-50 border border-red-200 py-8 mb-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="text-center">
                <Icon size={32} className="text-red-600 mx-auto mb-2" />
                <div className="text-2xl md:text-3xl font-bold text-red-600 mb-1">
                  {stat.number}
                </div>
                <div className="text-sm text-gray-600">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Mission & Vision */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
        <div className="border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-3">បេសកកម្មរបស់យើង</h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            ផ្តល់ជូនអតិថិជននូវផលិតផលញ៉ាំក្នុងស្រុកដែលមានគុណភាពខ្ពស់ និងតម្លៃសមរម្យ 
            រួមជាមួយសេវាកម្មក្រោយពេលលក់ដែលគួរទុកចិត្តបាន។
          </p>
        </div>
        <div className="border border-gray-200 p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-3">ចក្ខុវិស័យរបស់យើង</h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            ក្លាយជាវេបសាយលក់ផលិតផលញ៉ាំក្នុងស្រុកឈានមុខគេនៅកម្ពុជា 
            ដែលត្រូវបានគេស្គាល់ពីគុណភាព និងសេវាកម្មដ៏ល្អឥតខ្ចោះ។
          </p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="text-center mb-12">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6">
          ហេតុអ្វី<span className="text-red-600">ជ្រើសរើសយើង?</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="border border-gray-200 p-5">
            <div className="text-red-600 text-3xl mb-3">✓</div>
            <h3 className="font-semibold text-gray-800 mb-2">គុណភាពធានា</h3>
            <p className="text-gray-600 text-sm">ផលិតផលស្រស់ ១០០% ពីញ៉ាំក្នុងស្រុក</p>
          </div>
          <div className="border border-gray-200 p-5">
            <div className="text-red-600 text-3xl mb-3">💰</div>
            <h3 className="font-semibold text-gray-800 mb-2">តម្លៃសមរម្យ</h3>
            <p className="text-gray-600 text-sm">តម្លៃប្រកួតប្រជែង សមរម្យសម្រាប់អតិថិជនគ្រប់រូប</p>
          </div>
          <div className="border border-gray-200 p-5">
            <div className="text-red-600 text-3xl mb-3">🏆</div>
            <h3 className="font-semibold text-gray-800 mb-2">សេវាកម្មវិជ្ជាជីវៈ</h3>
            <p className="text-gray-600 text-sm">បុគ្គលិកជំនាញ បម្រើសេវាកម្មយ៉ាងឆាប់រហ័ស</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gray-50 border border-gray-200 p-6 text-center">
        <h2 className="text-xl font-bold text-gray-800 mb-3">
          ត្រៀមខ្លួនទិញផលិតផលស្រស់ៗហើយឬនៅ?
        </h2>
        <p className="text-gray-600 text-sm mb-4">
          ទស្សនា GrandFatherSmile ឥឡូវនេះ ដើម្បីទទួលបានការផ្តល់ជូនពិសេស
        </p>
        <div className="flex gap-3 justify-center">
          <Link
            to="/products"
            className="inline-block bg-red-600 text-white px-6 py-2 text-sm font-medium hover:bg-red-700 transition-colors"
          >
            ទិញឥឡូវនេះ
          </Link>
          <Link
            to="/contact"
            className="inline-block border border-red-600 text-red-600 px-6 py-2 text-sm font-medium hover:bg-red-50 transition-colors"
          >
            ទំនាក់ទំនង
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;